<template>
  <!-- 机构管理 -->
  <div class="payType">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['系统配置', $route.meta.title]">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleEdit('')">新增支付方式</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input v-model="searchForm.name" style="width:200px;margin-right:5px" clearable placeholder="输入名称">
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table :data="tableData" stripe border height="calc(100% - 130px)" tooltip-effect="dark"
      @selection-change="selectionChange" style="width: 100%">
      <el-table-column label="序号" type="index" align="center" width="50">
      </el-table-column>
      <!-- <el-table-column
        align="center"
        prop="entId"
        show-overflow-tooltip
        label="机构编号">
      </el-table-column> -->
      <el-table-column align="center" prop="payId" show-overflow-tooltip label="支付编号">
      </el-table-column>
      <el-table-column align="center" prop="payName" show-overflow-tooltip label="支付名称">
      </el-table-column>
      <el-table-column align="center" prop="payType" show-overflow-tooltip label="支付方式">
      </el-table-column>
      <el-table-column align="center" prop="status" show-overflow-tooltip label="状态">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 'Y'">已启用</el-tag>
          <el-tag type="danger" v-if="scope.row.status == 'N'">未启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" show-overflow-tooltip label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == 'Y'" type="warning" style="padding:2px 3px;" plain
            @click="changeStatus(scope.row, 'N')">禁用</el-button>
          <el-button v-if="scope.row.status == 'N'" type="success" style="padding:2px 3px;" plain
            @click="changeStatus(scope.row, 'Y')">启用</el-button>
          <el-button type="primary" style="padding:2px 3px;" plain @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加支付方式 -->
    <el-drawer title="" :visible.sync="addDrawer" :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape" :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl" size="32%">
      <div class="drawer-header">
        支付方式
      </div>
      <el-scrollbar style="height:calc(100% - 90px);">
        <div class="drawer-form-wrap">
          <el-form :model="addForm" label-position="rigth" label-width="160px" :rules="formRule" ref="addForm">
            <el-form-item label="支付类型" prop="payName">
              <el-select v-model="addForm.payName" style="width: 100%;">
                <el-option label="支付宝" value="支付宝"></el-option>
                <el-option label="微信" value="微信"></el-option>
                <el-option label="线下支付" value="线下支付"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-show="addForm.payName != '线下支付'" label="AppID" prop="appId" class="el-form-required-true">
              <el-input v-model="addForm.appId" clearable></el-input>
            </el-form-item>
            <el-form-item v-show="addForm.payName == '微信'" label="应用密钥(AppSecret)" prop="appSecert">
              <el-input v-model="addForm.appSecert" clearable></el-input>
            </el-form-item>
            <el-form-item v-show="addForm.payName == '微信'" label="商户号(MchID)" prop="merchants"
              class="el-form-required-true">
              <el-input v-model="addForm.merchants" clearable></el-input>
            </el-form-item>

            <el-form-item v-show="addForm.payName == '微信'" label="商户支付密钥(APIv2秘钥)" prop="appKey"
              class="el-form-required-true">
              <el-input v-model="addForm.appKey" clearable></el-input>
            </el-form-item>
            <el-form-item v-show="addForm.payName == '微信'" label="API证书地址" prop="SSlCertPath">
              <el-input v-model="addForm.SSlCertPath" clearable></el-input>
            </el-form-item>
            <el-form-item v-show="addForm.payName == '微信'" label="API证书密码" prop="SSlCertPassword">
              <el-input v-model="addForm.SSlCertPassword" clearable></el-input>
            </el-form-item>
            <el-form-item v-show="addForm.payName == '支付宝'" label="应用私钥" prop="privateKey" class="el-form-required-true">
              <el-input v-model="addForm.privateKey" type="textarea" clearable></el-input>
            </el-form-item>
            <el-form-item v-show="addForm.payName == '支付宝'" label="支付宝公钥" prop="publicKey" class="el-form-required-true">
              <el-input v-model="addForm.publicKey" type="textarea" clearable></el-input>
            </el-form-item>
            <el-form-item label="logo图片" >
              <img-view :imgList="[{ url: $setImgUrl(addForm.imgUrl), id: 0 }]">
              </img-view>
              <upload @fileChange="uploadImage" accept="image/jpg,image/jpeg,image/png">
              </upload>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js";//混入表单必填项

export default {
  name: 'payType',
  data() {
    return {
      /**表格数据 */
      // {
      //   entId:"机构编号",
      //   payId:"支付方式",
      //   payName:"支付名称",
      //   payType:"支付类型",
      //   status:"状态"
      // }
      tableData: [],
      /**搜索表单 */
      searchForm: {
        name: ""
      },
      addDrawer: false,/**新增drawer */
      /**表单数据 */
      addForm: {
        entId: '',
        entName: '',
        payId: '',
        payName: '',
        payType: '',
        status: '',
        appId: '',
        merchants: '',
        appKey: '',
        appSecert: '',
        SSlCertPath: '',
        SSlCertPassword: '',
        privateKey: '',
        publicKey: '',
        imgUrl:'',//logo图片
      },
      formRule: {/**表单验证 */
        payType: [mustFill],
        payName: [mustFill],
        appId: [this.payTypeFill('线下支付', true)],
        merchants: [this.payTypeFill('微信')],
        appKey: [this.payTypeFill('微信')],
        // appSecert: [this.payTypeFill('微信')],
        // SSlCertPath: [this.payTypeFill('微信')],
        // SSlCertPassword: [this.payTypeFill('微信')],
        privateKey: [this.payTypeFill('支付宝')],
        publicKey: [this.payTypeFill('支付宝')],
      },
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    /**获取表格数据 */
    getTableData() {
      let data = {
        entId: localStorage.getItem('entId')
      }
      this.$request({
        url: 'Base/GetEntPayTypeList',
        method: 'post',
        data: data
      }).then(res => {
        // console.log(res);
        this.tableData = []
        if (res.success) {
          this.allPage = (res.list && res.list.length) || 0;
          this.tableData = res.list.map(item => ({
            entId: item.EntId,
            payId: item.PayId,
            payName: item.PayType,
            payType: item.PayType == '线下支付' ? '线下支付' : '线上支付',
            status: item.IsPayment.trim(),
            appId: item.AppId,
            merchants: item.Merchants,
            appKey: item.AppKey,
            appSecert: item.AppSecert,
            SSlCertPath: item.SSlCertPath,
            SSlCertPassword: item.SSlCertPassword,
            privateKey: item.PrivateKey,
            publicKey: item.PublicKey,
            imgUrl: item.LogoUrl,
          }))
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**新增机构 */
    handleEdit(row) {
      this.clearForm()
      if (row) {
        for (const key in this.addForm) {
          this.addForm[key] = row[key]
        }
      } else {
        this.addForm.payName = '支付宝'
      }
      this.addDrawer = true;
    },
    // 支付方式参数控制
    payTypeFill(type, isBack) {
      return {
        validator: (rule, value, callback) => {
          let isCheck = false
          if (isBack) {
            isCheck = this.addForm.payName != type
          } else {
            isCheck = this.addForm.payName == type
          }
          if (isCheck) {
            if (!value) {
              return callback(new Error('该字段为必填项'))
            } else {
              return callback()
            }
          } else {
            return callback()
          }
        }
      }
    },
    changeStatus(row, status) {
      let msg = '确定要执行操作吗?'
      let msgType = 'info'
      if (status == 'Y') {
        msg = '确定启用吗?'
        msgType = 'success'
      } else if (status == 'N') {
        msg = '确定禁用吗?'
        msgType = 'warning'
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: msgType
      }).then(() => {
        let data = {
          type: "UpdateStatus",
          payId: row.payId,
          status: status
        };
        let proc = "pro_paymentAdmin";//存储过程名
        let type = "ReturnNumber";
        this.$requestSys({
          url: 'payment/ashx/ReturnJson.ashx',
          method: "post",
          data: { proc: proc, type: type, json: JSON.stringify(data) },
        }).then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getTableData();
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        }).catch((err) => {
          window.console.log(err);
        });
      }).catch(() => { });
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = '';
      }
      this.addDrawer = false;
    },

    /**文件上传回调 */
    uploadImage(file) {
      // if (file.length) {
      //   //将上传的图片file对象直接转化为blob地址，无需重新获取图片
      //   this.addForm.imgUrl = URL.createObjectURL(file[0])
      // }
      let formData = new FormData();
      file.forEach((ele, index) => {
        formData.append('file' + index, ele);
      });
      this.$uploadRequest({
        url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=payType",
        method: "post",
        data: formData
      }).then((res) => {
        this.addForm.imgUrl = res.message
      }).catch((err) => {
        console.log(err);
      });
    },

    /**提交表单 */
    submitForm() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          let data = {
            EntId: localStorage.getItem('entId'),
            PayId: this.addForm.payId,
            AppId: this.addForm.appId,
            Merchants: this.addForm.merchants,
            AppKey: this.addForm.appKey,
            AppSecert: this.addForm.appSecert,
            SSlCertPath: this.addForm.SSlCertPath,
            SSlCertPassword: this.addForm.SSlCertPassword,
            PayType: this.addForm.payName,
            PrivateKey: this.addForm.privateKey,
            PublicKey: this.addForm.publicKey,
            LogoUrl: this.addForm.imgUrl
          }
          this.$request({
            url: 'Base/SaveEntPayType',
            method: 'post',
            data: data
          }).then(res => {
            if (res.success) {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.clearForm()
              this.getTableData()
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              })
            }
          })
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.payType {
  width: 100%;
  height: 100%;
}
</style>
